import { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Copy, RefreshCcw, Search, SlidersHorizontal, X
} from 'lucide-react';
import { FaTwitter, FaInstagram, FaTiktok, FaFilter, FaAngleDown } from "react-icons/fa";
import { useSelector, useDispatch } from "react-redux";


// components
import BackDrop from "../components/backdrop";
import UpdateInfo  from "../components/updateInfo";
import CheckinBox from "../components/checkinBox";
import BreathingExercise from "../components/breathingExercise";
import MoodLogModal from "../components/moodlogmodal";
import MoodRing from "../components/moodring";
import WellnessScore from "../components/wellness-score";

// states_g
import { setgtMessage } from "../redux/gtmsgSlice";
import { gtNeutral } from "../redux/gtstatusSlice";
import { openModal, closeModal } from "../redux/moodmodalSlice";
import { setmodalgeneral } from "../redux/modalsSlice";

// hooks
import { useAppuserout } from "../hooks/general/useAppuserout";
import { useAiscore } from "../hooks/general/useAiscore";

// utilities
import { icons } from "../utilities/icn";
import { images } from "../utilities/img";
import { allQuestions } from "../utilities/allQuestions";
// import MoodMessage from "../components/moodmessage";


const Ghost = () => {  

    const navigate = useNavigate()
    const { checkAppUser } = useAppuserout()
    const { handleAiscore } = useAiscore()
    
    const user = useSelector((state) => state.user.value)
    const modalgeneral = useSelector((state) => state.modalgeneral.value)
    const showModal = useSelector((state) => state.showmodal.value)
    const moodadd = useSelector((state) => state.moodadd.value)
    
    const dispatch = useDispatch()
    
    const [windowWidth, setWindowWidth] = useState(window.innerWidth)
    const [breathingexercise, setbe] = useState(null)
    const [checkin, setcheckinbox] = useState(null)
    const [enterinfo, setEnterinfo] = useState(true)
    const [demodep, setdemodep] = useState(null)
    const [searchca, setsearchca] = useState("")
    const [activeca, setactiveca] = useState(null)

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        // Cleanup: Remove the event listener when the component is unmounted
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    
    const setAlltoNull = () => {
        setEnterinfo(null)
        setcheckinbox(null)
        setbe(null)
        dispatch(closeModal())
        dispatch(setmodalgeneral(null))
    }



    return ( 

        <div className="ghost">

            {modalgeneral || showModal ?
                <BackDrop dropPress={setAlltoNull} />
            : null}

            <div className="flex justify-space-between row align-center mgb-30 ghost-head gap-15">
                
                <div className="ghost-search-input flex row align-center gap-10">
                    <Search size={20} color="rgba(255, 255, 255, 1)" />
                    <input type="text" className="hn_medium d-white_c" placeholder="Paste CA here..." onChange={(e) => setsearchca(e.target.value)} />
                </div>

                <div className="ghost-search-btn flex align-center cursor-pointer">
                    <p className="hn_bold">Search</p>
                </div>

            </div>

            <div className={`ghost-details-box ${!activeca ? 'height80' : ''}`}>

                {searchca === "" && !activeca ?  <div className="">
                    <h3 className="hn_medium d-white_c mgb-40 text-transform-capitalize">your ghost positions</h3>

                    <div className="ghost-table-head flex row">
                        <div className="ghost-table-head-item token">
                            <h5 className="hn_medium text-transform-uppercase n400_c">token</h5>
                        </div>
                        <div className="ghost-table-head-item size">
                            <h5 className="hn_medium text-transform-uppercase n400_c">size</h5>
                        </div>
                        <div className="ghost-table-head-item entry">
                            <h5 className="hn_medium text-transform-uppercase n400_c">entry</h5>
                        </div>
                        <div className="ghost-table-head-item pnl">
                            <h5 className="hn_medium text-transform-uppercase n400_c">pnl</h5>
                        </div>
                    </div>
                </div> : null}

                {searchca !== "" && !activeca ? 
                    <div className="ca-results-box">
                        <h6 className="mgb-10 hn_medium text-transform-uppercase">results</h6>

                        <div className="">

                            <div className="result-item active flex justify-space-between row align-center cursor-pointer" onClick={() => setactiveca("samo")}>
                                <div className="flex row align-center gap-20">
                                    <div className="result-dp overflow-y-hidden">
                                        <img src={images.general.samo_dp1} alt="" />
                                    </div>
                                    <div className="flex row gap-10">
                                        <h5 className="hn_medium d-white_c text-transform-uppercase">samo</h5>
                                        <h5 className="hn_medium n400_c">Samoyedcoin</h5>
                                    </div>
                                </div>

                                <div className="flex row gap-20 align-center">
                                    <div className="flex row gap-5 align-center">
                                        <h6 className="hn_medium d-white_c text-transform-uppercase">mc</h6>
                                        <h6 className="hn_medium d-white_c text-transform-uppercase">$3k</h6>
                                    </div>
                                    <div className="flex row gap-5 align-center">
                                        <h6 className="hn_medium d-white_c text-transform-uppercase">v</h6>
                                        <h6 className="hn_medium d-white_c text-transform-uppercase">$0</h6>
                                    </div>
                                    <div className="flex row gap-5 align-center">
                                        <h6 className="hn_medium d-white_c text-transform-uppercase">l</h6>
                                        <h6 className="hn_medium d-white_c text-transform-uppercase">$5k</h6>
                                    </div>
                                </div>
                            </div>

                            <div className="result-item active flex justify-space-between row align-center">
                                <div className="flex row align-center gap-20">
                                    <div className="result-dp overflow-y-hidden">
                                        <img src={images.general.samo_dp2} alt="" />
                                    </div>
                                    <div className="flex row gap-10">
                                        <h5 className="hn_medium d-white_c text-transform-uppercase">samo</h5>
                                        <h5 className="hn_medium n400_c">Samoyedcoin</h5>
                                    </div>
                                </div>

                                <div className="flex row gap-20 align-center">
                                    <div className="flex row gap-5 align-center">
                                        <h6 className="hn_medium d-white_c text-transform-uppercase">mc</h6>
                                        <h6 className="hn_medium d-white_c text-transform-uppercase">$3k</h6>
                                    </div>
                                    <div className="flex row gap-5 align-center">
                                        <h6 className="hn_medium d-white_c text-transform-uppercase">v</h6>
                                        <h6 className="hn_medium d-white_c text-transform-uppercase">$0</h6>
                                    </div>
                                    <div className="flex row gap-5 align-center">
                                        <h6 className="hn_medium d-white_c text-transform-uppercase">l</h6>
                                        <h6 className="hn_medium d-white_c text-transform-uppercase">$5k</h6>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                : null}

                {activeca ? 
                    <div className="active-ca-box">

                        <div className="flex row justify-space-between align-center mgb-55">
                            <div className="flex row align-center gap-15">
                                <div className="result-dp overflow-y-hidden">
                                    <img src={images.general.samo_dp1} alt="" />
                                </div>
                                <div className="">
                                    <h4 className="hn_medium d-white_c text-transform-uppercase mgb-5">samo</h4>
                                    <h5 className="hn_medium n400_c">Samoyedcoin</h5>
                                </div>
                                <Copy size={20} color="rgba(80, 80, 80, 1)" className="cursor-pointer" />
                            </div>

                            <div className="">
                                <h4 className="hn_medium n400_c mgb-5">Market Cap</h4>
                                <h2 className="hn_medium active">$4.43k</h2>
                            </div>
                        </div>

                        <div className={`mgb-35 flex row align-center ${windowWidth < 600 ? 'gap-20' : 'gap-150'}`}>
                            <div className="">
                                <h5 className="hn_medium n400_c mgb-5">Price</h5>
                                <h2 className="hn_medium d-white_c">$0.054</h2>
                            </div>
                            <div className="">
                                <h5 className="hn_medium n400_c mgb-5">Liquidity</h5>
                                <h2 className="hn_medium d-white_c">$8.79K</h2>
                            </div>
                            <div className="">
                                <h5 className="hn_medium n400_c mgb-5">Supply</h5>
                                <h2 className="hn_medium d-white_c">1B</h2>
                            </div>
                        </div>

                        <div className={`mgb-55 flex row align-center ${windowWidth < 600 ? 'gap-20' : 'gap-150'}`}>
                            <div className="">
                                <h5 className="hn_medium n400_c mgb-5">Global Fees Paid</h5>
                                <div className="flex align-center gap-5">
                                    <img src={images.general.sol_logo} className="sol-fees-logo" alt="" />
                                    <h2 className="hn_medium d-white_c">1.111</h2>
                                </div>
                            </div>
                            <div className="">
                                <h5 className="hn_medium n400_c mgb-5">B. Curve</h5>
                                <h2 className="hn_medium green">10.17%</h2>
                            </div>
                        </div>

                        <div className="">
                            <h5 className="hn_medium n400_c mgb-15">B. Curve</h5>

                            <div className="active-ca-to-sol-box">
                                <div className="active-ca-to-sol-inner flex row align-center justify-space-between line">
                                    <input type="number" className="hn_medium d-white_c" placeholder="1" />
                                    <div className="flex row align-center gap-10">
                                        <h4 className="hn_medium d-white_c text-transform-uppercase">samo</h4>
                                        <img src={images.general.samo_dp1} className="sol-fees-logo" alt="" />
                                    </div>
                                </div>

                                <div className="active-ca-to-sol-inner flex row align-center justify-space-between">
                                    <input type="number" className="hn_medium d-white_c" placeholder="0.00000469" />
                                    <div className="flex row align-center gap-25">
                                        <h5 className="d-white_c hn_medium text-transform-uppercase cursor-pointer active">usd</h5>
                                        <div className="flex row align-center gap-10 cursor-pointer">
                                            <h4 className="hn_medium d-white_c text-transform-uppercase">samo</h4>
                                            <img src={images.general.sol_logo} className="sol-fees-logo" alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                : null}

            </div>

            
        </div>

        
            


    );
}
 
export default Ghost;